import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { selectPendingOrders } from "../../redux/features/order/OrderSlice";
import dayjs from "dayjs";
// import { IoEyeSharp } from "react-icons/io5";
import { GiKnifeFork } from "react-icons/gi";
import axios from "axios";
import { toast } from "react-toastify";

const printUrl = process.env.REACT_APP_PRINT_URL;
export const sendInvoiceToPrinter = async (currentOrder) => {
  try {
    const invoice = {
      invoiceNo: currentOrder?.orderNo,
      tableNo: currentOrder?.tableNo,
      waiter: currentOrder?.username,
      items: currentOrder?.products?.map((product) => ({
        name: product?.name,
        quantity: product?.quantity,
      })),
      dateTime: currentOrder?.createdAt,
    };

    const response = await axios.post(printUrl, invoice, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000,
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    let errorMessage = "Unknown printer error";

    if (error.code === "ECONNABORTED") {
      errorMessage = "Printer server timeout (10 seconds exceeded)";
    } else if (error.response) {
      errorMessage =
        error.response?.data?.message ||
        `Printer server returned ${error.response.status}`;
    } else if (error.request) {
      errorMessage =
        "Unable to connect to printer server. Check network connection.";
    } else {
      errorMessage = error.message;
    }

    return {
      success: false,
      message: errorMessage,
      status: error.response?.status || null,
    };
  }
};

const KitchenPrint = ({ id }) => {
  const printRef = useRef();

  const pendingOrders = useSelector(selectPendingOrders);

  const currentOrder = pendingOrders?.find((order) => order._id === id);
  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;
  const handlePrint = async () => {
    const result = await sendInvoiceToPrinter(currentOrder);

    if (!result.success) {
      toast.error(result.message);
    } else {
      toast.success("Invoice printed successfully");
      return
    }

    const isMobile =
      /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768;

    if (isMobile) {
      const printContent = printRef.current.innerHTML;
      const win = window.open("", "_blank");

      win.document.write(`
      <html>
        <head>
          <title>Print Receipt</title>
          <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
          <style>
            @media print {
              body { padding: 20px; }
            }
          </style>
        </head>
        <body onload="window.print();">
          ${printContent}
        </body>
      </html>
    `);

      win.document.close();
    } else {
      const printContent = printRef.current;
      if (!printContent) return;

      const styles = Array.from(document.styleSheets)
        .map((sheet) => {
          try {
            return Array.from(sheet.cssRules)
              .map((rule) => rule.cssText)
              .join("\n");
          } catch (err) {
            return "";
          }
        })
        .join("\n");

      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles}            ${printStyles}

          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
           
            }
            .text-[.8rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
      doc.close();

      iframe.contentWindow.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      };
    }
    // const originalContent = document.body.innerHTML;

    // document.body.innerHTML = printContent.innerHTML;
    // window.print();
    // document.body.innerHTML = originalContent;
    // window.location.reload();
  };

  return (
    <>
      <button
        onClick={handlePrint}
        title="kitchen receipt"
        className="capitalize lg:px-3 px-2 rounded-xl font-bold text-white py-2 bg-slate-500"
      >
        <GiKnifeFork className="lg:size-6 size-[1.1rem]" />
      </button>
      <div className="hidden invisible">
        <div ref={printRef} className="flex justify-center items-center ">
          <div className=" m-1  bg-white  flex flex-col gap-0.5">
            {/* order no */}

            <div className="w-full text-center space-y-1">
              <h1 className="text-[.8rem]  uppercase tracking-[.1em]  text-black">
                <p>Invoice #{currentOrder?.orderNo}</p>
              </h1>
              <h1 className="text-[.8rem]  uppercase tracking-[.1em]  text-black">
                <p>Table No #{currentOrder?.tableNo}</p>
              </h1>
            </div>

            <div className="flex justify-between items-center border-y border-[#000] p-2">
              <p className="text-black text-[12px]  uppercase tracking-[.1em] ">
                Waiter:{" "}
                <span className=" text-[12px]  uppercase tracking-[.1em] ">
                  {currentOrder?.username}
                </span>
              </p>
            </div>
            {/* Middle Section */}
            <div>
              {currentOrder?.products?.map((item, index) => (
                <div
                  key={item._id}
                  className={`flex items-start  w-full p-1 
                    ${index !== 0 ? "border-t border-[#000]" : ""}
                  `}
                >
                  <div className="flex flex-col flex-1 gap-1">
                    <h2 className="text-black text-[.7rem]  uppercase tracking-[.1em]  ">
                      {item.name}{" "}
                    </h2>
                    {item?.name?.includes("deal") && (
                      <h2 className="text-black text-[.6rem]  uppercase tracking-[.1em] ">
                        {item?.description}{" "}
                      </h2>
                    )}
                  </div>
                  <div className="flex items-center justify-end w-[25%] text-black text-[.7rem]  uppercase tracking-[.1em] ">
                    <p className="">X{item.quantity}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Lower Section */}
            <div className="flex justify-center items-center text-black  text-[14px] pb-6  uppercase tracking-[.12em] ">
              <p>
                {dayjs(currentOrder?.createdAt).format("D /M /YYYY . h:mm A")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KitchenPrint;
